<template>
  <div class="self-container" :class="{open: show}">
    <div class="btn" @click="modalTaggle">
      <img src="@/assets/img/self-btn.png" alt="">
      <p>自评结果</p>
    </div>
    <div class="self-content">
      <div class="answer-list">
        <div class="answer-item" v-for="item in info.answer" :key="item.key">{{ item.content }}</div>
        <div class="more" @click="detail">查看完整自评题目</div>
      </div>
      <van-icon name="arrow-left" class="close" @click="modalTaggle" />
    </div>
    <van-popup class="detail-modal" v-if="detailShow" v-model="detailShow" :close-on-click-overlay="false">
      <div class="container">
        <div class="scroll">
          <div class="title">{{ info.title }}</div>
          <div class="option-list" v-if="info.t_type * 1 === 1 || info.t_type * 1 === 2">
            <div class="option-item" v-for="item in info.option" :key="item.key" :class="{cur:info.answer.some(e => e.key * 1 === item.key*1)}">
              {{ item.content }}
            </div>
          </div>
        </div>
      </div>
      <div class="close-btn" @click="detailShow = false">×</div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "SelfModal",
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      show: false,
      detailShow: false,
    };
  },
  methods: {
    modalTaggle() {
      this.show = !this.show;
    },
    detail() {
      this.detailShow = true;
    }
  }

}
</script>

<style lang="less" scoped>
.self-container {
  height: 100vh;
  height: 100dvh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;

  .btn {
    width: 0.3rem;
    height: 1.1rem;
    background: #ffd57e;
    border-radius: 0 0.15rem 0.15rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: "pingfang-sc";
    font-size: 0.14rem;
    color: #630200;
    position: absolute;
    left: 0;
    bottom: 2.4rem;
    transition: all 0.3s;
    img {
      width: 0.16rem;
      height: 0.16rem;
      margin-bottom: 0.08rem;
    }
    p {
      width: 0.18rem;
      text-align: center;
      line-height: 1.1;
    }
  }
  .self-content {
    width: max-content;
    height: fit-content;
    min-height: 0.6rem;
    max-height: 100%;
    max-width: 80vw;
    position: absolute;
    bottom: 2.4rem;
    left: -80vw;
    background: linear-gradient(346deg, #ffd57e 0%, #ffe7b7 100%);
    padding: 0.1rem;
    border-radius: 0 0.14rem 0.14rem 0;
    transition: left 0.3s;
    display: flex;
    align-items: center;
    .more {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      font-size: 0.12rem;
      color: #f14947;
      line-height: 1;
      margin: 0.1rem 0 0.1rem 0.1rem;
    }
    .answer-list {
      display: flex;
      flex-wrap: wrap;
      .answer-item {
        font-size: 0.16rem;
        color: #bb0400;
        line-height: 0.3rem;
        border: 1px solid #f9cd98;
        border-radius: 0.15rem;
        background: #ffebd4;
        padding: 0 0.16rem;
        margin: 0.05rem;
        word-break: break-all;
      }
    }
    .close {
      font-size: 0.18rem;
      color: #bb0400;
      margin-left: 0.1rem;
    }
  }
  &.open {
    .btn {
      opacity: 0;
    }
    .self-content {
      left: 0;
      box-shadow: 4px 6px 2px 1px rgba(255, 180, 82, 0.839);
    }
  }
}
.van-popup {
  background: linear-gradient(180deg, #f7bb94 0%, #f7ae9a 100%);
  border-radius: 0.16rem;
  padding: 0.1rem;
  overflow: unset;
  .container {
    background: linear-gradient(180deg, #ffdeb9 0%, #fff7ee 100%);
    box-shadow: 0 0 0.2rem 1px rgba(191, 41, 0, 0.62);
    border-radius: 0.14rem;
    padding-bottom: 0.2rem;
  }
  .close-btn {
    position: absolute;
    right: 0;
    top: 0;
    width: 0.2rem;
    height: 0.2rem;
    line-height: 0.2rem;
    text-align: center;
    background: linear-gradient(180deg, #ff8927 0%, #ff6238 100%);
    border: 1px solid #ffd98b;
    border-radius: 50%;
    color: #fff;
    font-size: 0.16rem;
    cursor: pointer;
  }
}
.detail-modal {
  width: 4.6rem;
  .container {
    padding: 0.2rem 0.25rem;
    line-height: 1.5;
    max-height: 70vh;
    overflow-y: scroll;
  }
  .title {
    font-size: 0.18rem;
    font-weight: bold;
    color: #d45500;
  }
  .option-item {
    background: linear-gradient(180deg, #fff6e5 0%, #ffebd4 100%);
    border-radius: 0.2rem;
    margin-top: 0.12rem;
    font-size: 0.15rem;
    color: #630200;
    word-break: break-all;
    padding: 0.08rem 0.2rem;
    border: 1px solid #ffc763;
    &.cur {
      background: linear-gradient(180deg, #ffe56f 0%, #ffd519 100%);
    }
  }
}
</style>